import { useTranslation } from 'react-i18next';

import { ImageComponent } from '../Image';
import { GameStaticCategories } from '@/helpers/game';
import { oneRowSliderParams } from '@/helpers/games';
import LobbyGamesSlider from '@/modules/lobby/components/LobbyGamesSlider';
import { useCommonStore } from '@/store';

export const RecentGames = () => {
  const { t } = useTranslation('common');
  const recentGames = useCommonStore.use.recentGames();

  if (!recentGames.length) return null;

  return (
    <LobbyGamesSlider
      categoryId={GameStaticCategories.Recent}
      title={t(`common:gameCategories:${GameStaticCategories.Recent}`)}
      titleIcon={
        <ImageComponent width={24} height={24} src="/clock.webp" alt="icon" />
      }
      gamesList={recentGames}
      sliderParams={oneRowSliderParams}
    />
  );
};
